import { DOC_FORMAT_CONFIG_PREDEFINED } from '../define/global';
import {
  NAVERWORKS_FOLDER_TYPE_NAME,
  NAVERWORKS_SUPPORT_IMAGE_EXT
} from '../define/naverworksDefine';
import IconHWP from '../img/ico_file_32_hwp.png';
import IconSLIDE from '../img/ico_file_32_slide.png';
import IconSHEET from '../img/ico_file_32_sheet.png';
import IconWORD from '../img/ico_file_32_word.png';
import IconFOLDER from '../img/ico_folder.png';
import IconImage from '../img/file_image.png';
import { getExtension } from './FileControlUtil';

import ThumbnailIconFolder from '../img/naverWorksFileIcon/folder.png';
import ThumbnailIconHWP from '../img/naverWorksFileIcon/hwp.png';
import ThumbnailIconWORD from '../img/naverWorksFileIcon/docx.png';
import ThumbnailIconSHEET from '../img/naverWorksFileIcon/xlsx.png';
import ThumbnailIconSLIDE from '../img/naverWorksFileIcon/pptx.png';
import ThumbnailIconIMAGE from '../img/naverWorksFileIcon/image.png';
import ThumbnailIconUnknown from '../img/naverWorksFileIcon/unknown.png';

export const isFolder = (fileType) => `${fileType}`.toLowerCase() === NAVERWORKS_FOLDER_TYPE_NAME;

export const getFileIcon = (fileType, fileName, isThumbnailView) => {
  if (isFolder(fileType)) {
    return isThumbnailView ? ThumbnailIconFolder : IconFOLDER;
  } else {
    const convFileName = getExtension(fileName).toLowerCase();
    if (DOC_FORMAT_CONFIG_PREDEFINED.HWP.extList.includes(convFileName))
      return isThumbnailView ? ThumbnailIconHWP : IconHWP;
    if (DOC_FORMAT_CONFIG_PREDEFINED.WORD.extList.includes(convFileName))
      return isThumbnailView ? ThumbnailIconWORD : IconWORD;
    if (DOC_FORMAT_CONFIG_PREDEFINED.SHEET.extList.includes(convFileName))
      return isThumbnailView ? ThumbnailIconSHEET : IconSHEET;
    if (DOC_FORMAT_CONFIG_PREDEFINED.SLIDE.extList.includes(convFileName))
      return isThumbnailView ? ThumbnailIconSLIDE : IconSLIDE;
    if (Object.keys(NAVERWORKS_SUPPORT_IMAGE_EXT).includes(convFileName))
      return isThumbnailView ? ThumbnailIconIMAGE : IconImage;

    return ThumbnailIconUnknown;
  }
};

export const convModifiedTime = (time) => {
  try {
    const newTime = new Date(time);
    return `${newTime.getFullYear()}.${newTime.getMonth()}.${newTime.getDay()} ${newTime.getHours()}:${newTime.getMinutes()}`;
  } catch (error) {
    return '';
  }
};
